import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function ContactPage() {
  return (
    <div className="pt-20">
      <ContactSection />
      <Footer />
    </div>
  );
}
